module.exports = __webpack_public_path__ + "static/media/video-reserva.41afb3aa.mov";